import { useSelector } from "react-redux";
import React from 'react';
import {Row, Col} from "reactstrap";
import "../../../../Assets/Scss/newHome2.scss";
import { Link } from "react-router-dom";
import { BASE_URL } from "../../../../Config/axiosInstance";


export default function MostTrending(argument) {

const { topRatedStores } = useSelector((state) => state.Stores);

	return(
		<>
    <div className="carousel pt-0 pb-0" id="recommended-res">
		       
<div class="three" style={{
	padding:"4vh 0"
}} >
  <h1>Most Trending Stores</h1>
</div>
		<Row>
			{topRatedStores.slice(0,15).map((store, i)=>{
				return(
				<Col  xl="2" sm="4" id="brands-index2">

                <Link  ata-toggle="tooltip" data-placement="top" title={store.store_details?.slug} to={`/store/${store.store_details?.slug}`} style={{padding: "0", margin: "0"}}>
					<img src={`${BASE_URL}/${store?.store_details?.image}`}
                      alt="store"
                      width="100%"
                      height="120px"
					  loading="lazy"
                      style={{ objectFit: "contain", borderRadius:"20px" }} />
                      </Link>
				</Col>

					)
			})}
			</Row>
	</div>
	</>
	)
}
